module.exports = __webpack_public_path__ + "static/img/wire_256.e58f1b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wire_256.png
// module id = 6K1e
// module chunks = 0